module.exports = {"TXTWCL_Deposit":{"id":"TXTWCL_Deposit","defaultMessage":"Déposer","track":"Deposit"}}